// extracted by mini-css-extract-plugin
module.exports = {"breadCrumbList":"breadcrumb_breadCrumbList__elsQi","chevron":"breadcrumb_chevron__DC8Ws","item":"breadcrumb_item__lE5Jj"};